import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import AuthPage from "../components/auth/AuthPage";

const LoginPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t("auth.login_meta_title")}</title>
      </Helmet>
      <AuthPage mode="login" />
    </>
  );
};

export default LoginPage;
